import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'

import { SelectDashboard } from 'Components/Form/SelectDashboard'
import * as CONST from 'Reducers/PickupTimes/const'

import { number } from 'Utils/Validators/formValidation'
import { validate } from 'Containers/Form/City/PickupTimes/PickupTimeAdd/validate'
import ConfirmableTimePicker from '../../../../../Components/Form/ConfirmableTimePicker'
import { get24HourTime as get24HourTimeLogic } from '../../../../../shared/libraries/utils/date'
import FormLabel from '../../../../../Components/Form/FormLabel'

const get24HourTime = date => get24HourTimeLogic(new Date(date))

class PickupTimeAddFormUnstyled extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      timeStart: null,
      timeStop: null,
    }
    this.daySelectHandler = this.daySelectHandler.bind(this)
  }

  render() {
    const { className, handleSubmit, initialValues } = this.props

    return (
      <form className={className} onSubmit={handleSubmit}>
        <Row>
          <Col xs={12}>
            <Field
              component={SelectDashboard}
              name="day"
              value={initialValues.day}
              props={{
                onChange: this.daySelectHandler,
                options: CONST.DAYS_OF_THE_WEEK,
                label: 'Day',
              }}
              validate={[number]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <FormLabel label="Start Time" />
            <Field
              id="timeStart"
              name="timeStart"
              component={props => (
                <React.Fragment>
                  <ConfirmableTimePicker
                    pickerId="timeStart"
                    pickerName="Start Time"
                    value={
                      this.state.timeStart
                        ? get24HourTime(this.state.timeStart)
                        : get24HourTime(initialValues.timeStart)
                    }
                    dialogTitle="Confirm pick up start time"
                    onChange={hoursStr => {
                      var [hours, minutes] = hoursStr.split(':')
                      var date = new Date()
                      date.setHours(Number(hours))
                      date.setMinutes(Number(minutes))
                      this.setState({ timeStart: date })
                      props.input.onChange(date)
                    }}
                  />
                  {props.meta.error && (
                    <span className="error-message">{props.meta.error}</span>
                  )}
                </React.Fragment>
              )}
            />
          </Col>
          <Col xs={6}>
            <FormLabel label="End Time" />
            <Field
              id="timeStop"
              name="timeStop"
              component={props => (
                <React.Fragment>
                  <ConfirmableTimePicker
                    pickerId="timeStop"
                    pickerName="End Time"
                    value={
                      this.state.timeStop
                        ? get24HourTime(this.state.timeStop)
                        : get24HourTime(initialValues.timeStop)
                    }
                    dialogTitle="Confirm pick up end time"
                    onChange={hoursStr => {
                      var [hours, minutes] = hoursStr.split(':')
                      var date = new Date()
                      date.setHours(Number(hours))
                      date.setMinutes(Number(minutes))
                      this.setState({ timeStop: date })
                      props.input.onChange(date)
                    }}
                  />
                  {props.meta.error && (
                    <span className="error-message">{props.meta.error}</span>
                  )}
                </React.Fragment>
              )}
            />
          </Col>
        </Row>
      </form>
    )
  }

  daySelectHandler(e, index, value) {
    const { change } = this.props

    change('day', value)
  }
}

PickupTimeAddFormUnstyled.propTypes = {
  initialValues: PropTypes.object.isRequired,
  pickupTimesList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string.isRequired,
      timeStart: PropTypes.string,
      timeStop: PropTypes.string,
    }),
  ),
}

PickupTimeAddFormUnstyled = reduxForm({
  form: 'pickupTimeAddForm',
  validate,
})(PickupTimeAddFormUnstyled)

const mapStateToProps = state => ({
  initialValues: {
    day: CONST.DAYS_OF_THE_WEEK[0].value,
    timeStart: moment()
      .hours(10)
      .minutes(0),
    timeStop: moment()
      .hours(12)
      .minutes(0),
  },
  pickupTimesList: state.pickupTimes.pickupTimesList,
})

PickupTimeAddFormUnstyled = connect(
  mapStateToProps,
  {},
)(PickupTimeAddFormUnstyled)

export default PickupTimeAddFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/City/PickupTimes/PickupTimeAdd/unstyled.js